import { AutogenModelOriginCity, AutogenRowOriginCity } from "./autogen/AutogenModelOriginCity";

export class ModelOriginCity extends AutogenModelOriginCity<RowOriginCity> {
	constructor() {
		super(RowOriginCity);
	}
}

export class RowOriginCity extends AutogenRowOriginCity {
}